import { render, staticRenderFns } from "./FormPrivacyPolicy.vue?vue&type=template&id=9a901800&"
import script from "./FormPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./FormPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports